import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/app/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/shared/lib/lazy-dynamic/dynamic-bailout-to-csr.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/shared/lib/lazy-dynamic/preload-chunks.js");
;
import(/* webpackMode: "eager" */ "/app/src/app/(site)/home/AchievementsSection.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/app/(site)/home/companion.module.css");
;
import(/* webpackMode: "eager" */ "/app/src/app/(site)/home/customerTrust.module.css");
;
import(/* webpackMode: "eager" */ "/app/src/app/(site)/home/cooperation.module.css");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/(site)/home/HeroSection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/(site)/home/HomeSectionReveal.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/app/(site)/home/ProjectSection.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/app/(site)/ui/Button.module.css");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/(site)/ui/Button.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/app/(site)/ui/StatsCard.module.css");
;
import(/* webpackMode: "eager" */ "/app/src/app/(site)/ui/TrustCard.module.css");
;
import(/* webpackMode: "eager" */ "/app/src/app/(site)/ui/SocialLinks.module.css");
;
import(/* webpackMode: "eager" */ "/app/src/app/(site)/ui/ServiceList.module.css");
;
import(/* webpackMode: "eager" */ "/app/src/app/(site)/home/timeline.module.css");
;
import(/* webpackMode: "eager" */ "/app/src/app/(site)/home/inspiration.module.css");
